// Flow types automatically removed

import classNames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';
import styles from './styles/DropZoneOverlay.scss';

export function DropZoneOverlay({ containerClass = '', isImageUploaderOverlay, visible }) {
    return visible ? (
        <div
            className={classNames(containerClass, styles.overlayContainer, {
                [styles.imageUploaderOverlayContainer]: isImageUploaderOverlay,
            })}
        >
            <div
                className={classNames(styles.overlay, {
                    [styles.visible]: visible,
                    [styles.imageUploaderOverlay]: isImageUploaderOverlay,
                })}
            >
                <div>
                    <div className={styles.bannerLine}>
                        <FormattedMessage
                            id="dibs-media-uploader.DropZoneOverlay.replace"
                            defaultMessage="Replace"
                        />
                    </div>
                    <div className={styles.bannerLine}>
                        <FormattedMessage
                            id="dibs-media-uploader.DropZoneOverlay.image"
                            defaultMessage="Image"
                        />
                    </div>
                </div>
            </div>
        </div>
    ) : null;
}
